import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './NoItemsIcon.module.scss';

type NoItemsIconProps = {
  externalBackgroundClassName?: string;
};

const NoItemsIcon: FC<NoItemsIconProps>= ({ externalBackgroundClassName }) => {
  const backgroundClassName = classNames(styles.background, externalBackgroundClassName);

  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="168"
         height="173"
         fill="none"
         viewBox="0 0 168 173">
      <ellipse cx="84"
               cy="151.5"
               className={styles.circle}
               rx="84"
               ry="21.5" />
      <mask id="path-2-inside-1_19480_21907">
        <path fillRule="evenodd"
              d="M23.5086 26.365c-.6902 0-1.2498.5595-1.2498 1.2498v3.7721h-3.7437c-.6934 0-1.2555.5621-1.2555 1.2555 0 .6933.5621 1.2554 1.2555 1.2554h3.7437v3.7721c0 .6902.5596 1.2498 1.2498 1.2498.6903 0 1.2498-.5596 1.2498-1.2498v-3.7721h3.7437c.6934 0 1.2555-.5621 1.2555-1.2554 0-.6934-.5621-1.2555-1.2555-1.2555h-3.7437v-3.7721c0-.6903-.5595-1.2498-1.2498-1.2498Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M23.5086 26.365c-.6902 0-1.2498.5595-1.2498 1.2498v3.7721h-3.7437c-.6934 0-1.2555.5621-1.2555 1.2555 0 .6933.5621 1.2554 1.2555 1.2554h3.7437v3.7721c0 .6902.5596 1.2498 1.2498 1.2498.6903 0 1.2498-.5596 1.2498-1.2498v-3.7721h3.7437c.6934 0 1.2555-.5621 1.2555-1.2554 0-.6934-.5621-1.2555-1.2555-1.2555h-3.7437v-3.7721c0-.6903-.5595-1.2498-1.2498-1.2498Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M22.2588 31.3869v1h1v-1h-1Zm0 2.5109h1v-1h-1v1Zm2.4996 0v-1h-1v1h1Zm0-2.5109h-1v1h1v-1Zm-1.4996-3.7721c0-.138.1118-.2498.2498-.2498v-2c-1.2425 0-2.2498 1.0072-2.2498 2.2498h2Zm0 3.7721v-3.7721h-2v3.7721h2Zm-4.7437 1h3.7437v-2h-3.7437v2Zm-.2555.2555a.2555.2555 0 0 1 .2555-.2555v-2c-1.2457 0-2.2555 1.0098-2.2555 2.2555h2Zm.2555.2554a.2554.2554 0 0 1-.2555-.2554h-2c0 1.2456 1.0098 2.2554 2.2555 2.2554v-2Zm3.7437 0h-3.7437v2h3.7437v-2Zm1 4.7721v-3.7721h-2v3.7721h2Zm.2498.2498a.2497.2497 0 0 1-.2498-.2498h-2c0 1.2425 1.0073 2.2498 2.2498 2.2498v-2Zm.2498-.2498a.2497.2497 0 0 1-.2498.2498v2c1.2425 0 2.2498-1.0073 2.2498-2.2498h-2Zm0-3.7721v3.7721h2v-3.7721h-2Zm4.7437-1h-3.7437v2h3.7437v-2Zm.2555-.2554a.2554.2554 0 0 1-.2555.2554v2c1.2457 0 2.2555-1.0098 2.2555-2.2554h-2Zm-.2555-.2555a.2555.2555 0 0 1 .2555.2555h2c0-1.2457-1.0098-2.2555-2.2555-2.2555v2Zm-3.7437 0h3.7437v-2h-3.7437v2Zm-1-4.7721v3.7721h2v-3.7721h-2Zm-.2498-.2498c.138 0 .2498.1118.2498.2498h2c0-1.2426-1.0073-2.2498-2.2498-2.2498v2Z"
            mask="url(#path-2-inside-1_19480_21907)" />
      <mask id="path-4-inside-2_19480_21907">
        <path fillRule="evenodd"
              d="M130.992 43.9416c-.691 0-1.25.5596-1.25 1.2498v3.7721h-3.744c-.693 0-1.255.5621-1.255 1.2555s.562 1.2555 1.255 1.2555h3.744v3.7721c0 .6902.559 1.2498 1.25 1.2498.69 0 1.249-.5596 1.249-1.2498v-3.7721h3.744c.694 0 1.256-.5621 1.256-1.2555s-.562-1.2555-1.256-1.2555h-3.744v-3.7721c0-.6902-.559-1.2498-1.249-1.2498Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M130.992 43.9416c-.691 0-1.25.5596-1.25 1.2498v3.7721h-3.744c-.693 0-1.255.5621-1.255 1.2555s.562 1.2555 1.255 1.2555h3.744v3.7721c0 .6902.559 1.2498 1.25 1.2498.69 0 1.249-.5596 1.249-1.2498v-3.7721h3.744c.694 0 1.256-.5621 1.256-1.2555s-.562-1.2555-1.256-1.2555h-3.744v-3.7721c0-.6902-.559-1.2498-1.249-1.2498Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M129.742 48.9635v1h1v-1h-1Zm0 2.511h1v-1h-1v1Zm2.499 0v-1h-1v1h1Zm0-2.511h-1v1h1v-1Zm-1.499-3.7721a.25.25 0 0 1 .25-.2498v-2c-1.243 0-2.25 1.0073-2.25 2.2498h2Zm0 3.7721v-3.7721h-2v3.7721h2Zm-4.744 1h3.744v-2h-3.744v2Zm-.255.2555c0-.1411.114-.2555.255-.2555v-2c-1.246 0-2.255 1.0098-2.255 2.2555h2Zm.255.2555a.2551.2551 0 0 1-.255-.2555h-2c0 1.2457 1.009 2.2555 2.255 2.2555v-2Zm3.744 0h-3.744v2h3.744v-2Zm1 4.7721v-3.7721h-2v3.7721h2Zm.25.2498a.25.25 0 0 1-.25-.2498h-2c0 1.2425 1.007 2.2498 2.25 2.2498v-2Zm.249-.2498a.2491.2491 0 0 1-.249.2498v2c1.242 0 2.249-1.0073 2.249-2.2498h-2Zm0-3.7721v3.7721h2v-3.7721h-2Zm4.744-1h-3.744v2h3.744v-2Zm.256-.2555a.256.256 0 0 1-.256.2555v2c1.246 0 2.256-1.0099 2.256-2.2555h-2Zm-.256-.2555a.256.256 0 0 1 .256.2555h2c0-1.2457-1.01-2.2555-2.256-2.2555v2Zm-3.744 0h3.744v-2h-3.744v2Zm-1-4.7721v3.7721h2v-3.7721h-2Zm-.249-.2498c.138 0 .249.1119.249.2498h2c0-1.2425-1.007-2.2498-2.249-2.2498v2Z"
            mask="url(#path-4-inside-2_19480_21907)" />
      <mask id="path-6-inside-3_19480_21907">
        <path fillRule="evenodd"
              d="M33.507 53.9854c-.5522 0-.9998.4476-.9998.9998v3.0178h-2.995c-.5547 0-1.0044.4496-1.0044 1.0043s.4497 1.0044 1.0044 1.0044h2.995v3.0177c0 .5521.4476.9998.9998.9998s.9999-.4477.9999-.9999v-3.0176h2.995c.5547 0 1.0043-.4497 1.0043-1.0044s-.4496-1.0043-1.0043-1.0043h-2.995v-3.0178c0-.5522-.4477-.9998-.9999-.9998Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M33.507 53.9854c-.5522 0-.9998.4476-.9998.9998v3.0178h-2.995c-.5547 0-1.0044.4496-1.0044 1.0043s.4497 1.0044 1.0044 1.0044h2.995v3.0177c0 .5521.4476.9998.9998.9998s.9999-.4477.9999-.9999v-3.0176h2.995c.5547 0 1.0043-.4497 1.0043-1.0044s-.4496-1.0043-1.0043-1.0043h-2.995v-3.0178c0-.5522-.4477-.9998-.9999-.9998Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M32.5072 58.003v1h1v-1h-1Zm-3.9994 1.0043h1-1Zm3.9994 1.0044h1v-1h-1v1Zm1.9997 0v-1h-1v1h1Zm0-2.0087h-1v1h1v-1Zm-.9997-3.0178-.0002.0002v-2c-1.1045 0-1.9998.8954-1.9998 1.9998h2Zm0 3.0178v-3.0178h-2v3.0178h2Zm-3.995 1h2.995v-2h-2.995v2Zm-.0044.0043.0001-.0019a.0008.0008 0 0 1-.0002.0005c0 .0002.0003-.0005.0014-.0017.0011-.0011.0019-.0014.0017-.0013l-.0005.0002.0019-.0001v-2c-1.107 0-2.0044.8974-2.0044 2.0043h2Zm.0044.0044-.0019-.0001a.0017.0017 0 0 1 .0005.0002c.0002.0001-.0006-.0002-.0017-.0014-.0011-.0011-.0014-.0019-.0014-.0017a.0014.0014 0 0 1 .0002.0006l-.0001-.002h-2c0 1.107.8974 2.0044 2.0044 2.0044v-2Zm2.995 0h-2.995v2h2.995v-2Zm1 4.0177v-3.0177h-2v3.0177h2Zm-.0002-.0002.0002.0002h-2c0 1.1044.8953 1.9998 1.9998 1.9998v-2Zm-.0001.0001.0001-.0001v2c1.1045 0 1.9999-.8954 1.9999-1.9999h-2Zm0-3.0176v3.0176h2v-3.0176h-2Zm3.995-1h-2.995v2h2.995v-2Zm.0043-.0044a.007.007 0 0 1-.0001.002l.0002-.0006c.0001-.0002-.0002.0006-.0013.0017-.0012.0012-.0019.0015-.0017.0014a.0008.0008 0 0 1 .0005-.0002l-.0019.0001v2c1.1069 0 2.0043-.8974 2.0043-2.0044h-2Zm-.0043-.0043.0019.0001-.0005-.0002c-.0002-.0001.0005.0002.0017.0013.0011.0012.0014.0019.0013.0017l-.0002-.0005.0001.0019h2c0-1.1069-.8974-2.0043-2.0043-2.0043v2Zm-2.995 0h2.995v-2h-2.995v2Zm-1-4.0178v3.0178h2v-3.0178h-2Zm.0001.0002-.0001-.0002h2c0-1.1044-.8954-1.9998-1.9999-1.9998v2Z"
            mask="url(#path-6-inside-3_19480_21907)" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M17.5094 76.5839c0 2.2255-1.7948 4.0219-3.9992 4.0219-2.2045 0-3.9992-1.7964-3.9992-4.0219 0-2.2255 1.7947-4.0219 3.9992-4.0219 2.2044 0 3.9992 1.7964 3.9992 4.0219Z" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M123.743 3.7664c0 1.5321-1.236 2.7664-2.75 2.7664s-2.749-1.2343-2.749-2.7664S119.479 1 120.993 1s2.75 1.2343 2.75 2.7664Z" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M147.489 25.1095c0 2.2255-1.795 4.0219-3.999 4.0219-2.205 0-4-1.7964-4-4.0219 0-2.2255 1.795-4.0219 4-4.0219 2.204 0 3.999 1.7964 3.999 4.0219Z" />
      <rect width="72.9882"
            height="29.3869"
            x="44.5054"
            y="58.7518"
            className={styles.skeleton}
            strokeWidth="2"
            rx="3" />
      <rect width="72.9882"
            height="29.3869"
            x="44.5054"
            y="95.1606"
            className={styles.skeleton}
            strokeWidth="2"
            rx="3" />
      <rect width="72.9882"
            height="29.3869"
            x="44.5054"
            y="22.343"
            className={styles.skeleton}
            strokeWidth="2"
            rx="3" />
      <line x1="50.7545"
            x2="70.0011"
            y1="29.1314"
            y2="29.1314"
            className={styles.firstTitle}
            strokeLinecap="round"
            strokeWidth="2" />
      <line x1="50.9416"
            x2="76.5621"
            y1="35.4088"
            y2="35.4088"
            className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2" />
      <line x1="50.7545"
            x2="70.0011"
            y1="65.5401"
            y2="65.5401"
            className={styles.title}
            strokeLinecap="round"
            strokeWidth="2" />
      <line x1="50.9416"
            x2="76.5621"
            y1="71.8175"
            y2="71.8175"
            className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2" />
      <line x1="50.7545"
            x2="70.0011"
            y1="101.949"
            y2="101.949"
            className={styles.title}
            strokeLinecap="round"
            strokeWidth="2" />
      <line x1="50.9416"
            x2="76.5621"
            y1="108.226"
            y2="108.226"
            className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2" />
      <path className={backgroundClassName}
            d="M141.292 87.2162c-.086 18.8498-15.436 34.1308-34.286 34.1308-18.8498 0-34.0616-15.281-33.9763-34.1308.0854-18.8498 15.4355-34.1307 34.2853-34.1307 18.85 0 34.062 15.2809 33.977 34.1307Z" />
      <path className={backgroundClassName}
            d="M137.764 87.2162c-.076 16.9018-13.84 30.6028-30.742 30.6028-16.9016 0-30.5412-13.701-30.4647-30.6028.0766-16.9017 13.8402-30.6031 30.7417-30.6031 16.902 0 30.542 13.7014 30.465 30.6031Z" />
      <path className={backgroundClassName}
            d="M129.908 118.692c-1.893-1.901-1.893-4.984 0-6.886l1.732-1.739c1.893-1.902 4.962-1.902 6.855 0l18.904 18.99c1.893 1.902 1.893 4.985 0 6.886l-1.731 1.74c-1.893 1.901-4.962 1.901-6.855 0l-18.905-18.991Z" />
      <path className={styles.loupe}
            d="M130.048 112.363c.592.596 1.553.596 2.146 0 .593-.595.593-1.561 0-2.156l-2.493-2.505c-.593-.596-1.554-.596-2.147 0-.593.595-.593 1.561 0 2.156l2.494 2.505Z" />
      <path className={styles.loupe}
            fillRule="evenodd"
            d="M107.031 115.819c15.798 0 28.662-12.806 28.733-28.6028.072-15.7971-12.676-28.6032-28.474-28.6032-15.797 0-28.6611 12.8061-28.7327 28.6032-.0715 15.7968 12.6767 28.6028 28.4737 28.6028Zm-.009 2c16.902 0 30.666-13.701 30.742-30.6028.077-16.9017-13.563-30.6031-30.465-30.6031-16.9015 0-30.6651 13.7014-30.7417 30.6031-.0765 16.9018 13.5631 30.6028 30.4647 30.6028Z"
            clipRule="evenodd" />
      <path className={styles.loupe}
            fillRule="evenodd"
            d="m133.051 111.484-1.732 1.74c-1.114 1.118-1.114 2.932 0 4.051l18.905 18.99c1.114 1.119 2.919 1.119 4.033 0l1.731-1.739c1.114-1.119 1.114-2.933 0-4.051l-18.904-18.991c-1.114-1.119-2.92-1.119-4.033 0Zm-3.143.322c-1.893 1.902-1.893 4.985 0 6.886l18.905 18.991c1.893 1.901 4.962 1.901 6.855 0l1.732-1.74c1.892-1.901 1.892-4.984-.001-6.886l-18.904-18.99c-1.893-1.902-4.962-1.902-6.855 0l-1.732 1.739Z"
            clipRule="evenodd" />
      <path className={styles.loupe}
            fillRule="evenodd"
            d="M132.194 112.363c-.593.596-1.554.596-2.146 0l-2.494-2.505c-.593-.595-.593-1.561 0-2.156.593-.596 1.554-.596 2.147 0l2.493 2.505c.593.595.593 1.561 0 2.156Z"
            clipRule="evenodd" />
      <path className={styles.loupe}
            d="M104.527 93.3289c.023-1.3396.175-2.3978.458-3.1745.282-.7768.859-1.638 1.729-2.5836l2.22-2.2796c.95-1.0694 1.424-2.2177 1.424-3.4447 0-1.1821-.31-2.1052-.932-2.7693-.622-.6755-1.526-1.0132-2.712-1.0132-1.153 0-2.08.3039-2.78.9118-.355.3081-.608.8201-.778 1.3073-.165.4742-.25.9248-.273 1.1412-.047.4387-.518 1.5185-1.758 1.5185s-1.3784-1.5185-1.3784-1.5185c.0226-1.8237.6724-3.2928 1.9494-4.4072 1.288-1.1258 2.961-1.6886 5.018-1.6886 2.136 0 3.797.5741 4.984 1.7223 1.197 1.137 1.796 2.7018 1.796 4.6943 0 1.9701-.915 3.912-2.746 5.8257l-1.848 1.8237c-.824.9118-1.237 2.2233-1.237 3.9344 0 0-.339 1.3473-1.579 1.3473-1.239 0-1.557-1.3473-1.557-1.3473Zm-.136 5.3529c0-.5066.153-.9287.458-1.2664.316-.349.78-.5235 1.39-.5235.61 0 1.074.1745 1.39.5235.317.3377.475.7598.475 1.2664 0 .5066-.158.9287-.475 1.2665-.316.3267-.78.4897-1.39.4897-.61 0-1.074-.163-1.39-.4897-.305-.3378-.458-.7599-.458-1.2665Z" />
    </svg>
  );
};

export default NoItemsIcon;
